import { useState } from 'react';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { Credit } from '@types';

export const useInterestReport = () => {
  const [isExporting, setIsExporting] = useState(false);

  const downloadInterestReport = async (
    credit: Credit,
    elementId = 'export-credit-interest',
    className?: any,
  ) => {
    setIsExporting(true);
    await new Promise((resolve) => setTimeout(resolve, 250));

    const div = document.getElementById(elementId);
    const plusCell = document.getElementById('plusCell');
    const delBtns = document.querySelectorAll('.delBtn');
    const icons = document.querySelectorAll('.amountIcon');
    const amountInputs = document.querySelectorAll('.amountInput input');
    const pdfFilename = `Tabla_Intereses_${credit.code}_#${credit.accreditedName}.pdf`;

    if (plusCell) {
      plusCell.style.opacity = '0';
    }
    if (delBtns.length) {
      delBtns.forEach((btn) => {
        btn.classList.add(className?.hidden || 'hidden');
      });
    }
    if (icons.length && amountInputs.length) {
      icons.forEach((btn) => {
        btn.classList.add(className?.iconExport || 'iconExport');
      });
      amountInputs.forEach((btn) => {
        btn.classList.add(className?.inputExport || 'inputExport');
      });
    }

    try {
      div && html2canvas(div).then((canvas) => {
        const imgWidth = 295;
        const pageHeight = 208;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;
        let position = 0;
        heightLeft -= pageHeight;
        const doc = new jsPDF('landscape', 'mm');
        doc.addImage(canvas, 'PNG', 0, position, imgWidth, imgHeight, '', 'FAST');
        while (heightLeft >= 0) {
          position = heightLeft - imgHeight;
          doc.addPage();
          doc.addImage(canvas, 'PNG', 0, position, imgWidth, imgHeight, '', 'FAST');
          heightLeft -= pageHeight;
        }
        doc.save(pdfFilename);
      });
    } finally {
      setIsExporting(false);
    }

    if (plusCell) {
      plusCell.style.opacity = '1';
    }
    if (delBtns.length) {
      delBtns.forEach((btn) => {
        btn.classList.remove(className?.hidden || 'hidden');
      });
    }
    if (icons.length && amountInputs.length) {
      icons.forEach((btn) => {
        btn.classList.remove(className?.iconExport || 'iconExport');
      });
      amountInputs.forEach((btn) => {
        btn.classList.remove(className?.inputExport || 'inputExport');
      });
    }
  };

  return { isExporting, downloadInterestReport };
};
